'use client';

import { useState, useEffect } from 'react';

type Result = {
  rating: number;
  name: string;
  loading: boolean;
};

const initialResult: Result = {
  rating: 0,
  name: '',
  loading: true,
};

export function useRatingReviews() {
  const [result, setResult] = useState<Result>(initialResult);

  useEffect(() => {
    const fetchData = async () => {
      setResult((prev) => ({ ...prev, loading: true }));
      const request = await fetch(`/api/google-rating-reviews`);
      if (request.ok) {
        const response = await request.json();

        setResult({
          rating: response?.rating || 0,
          name: response?.name || '',
          loading: false,
        });
      }
    };
    fetchData();
  }, []);

  return result;
}
